import { CREATE_ACCOUNT_HREF, SIGN_IN_HREF } from "./constants";
import { Footer } from "./styles";

export function WelcomeFooter() {
  return (
    <Footer>
      <p>Net Worth Tracker · One clear financial picture.</p>
      <nav aria-label="Footer">
        <a href={SIGN_IN_HREF}>Sign in</a>
        <a href={CREATE_ACCOUNT_HREF}>Create account</a>
        <a href="/terms">Terms</a>
        <a href="/privacy">Privacy</a>
        <a href="#top">Back to top</a>
      </nav>
    </Footer>
  );
}
